// src/data/teamData.js
import team1 from "../assets/images/team/Jenny.jpeg";
import team2 from "../assets/images/team/sireesha.jpeg";
import team3 from "../assets/images/team/akshay.jpeg";
import team4 from "../assets/images/team/pushpa.jpeg";
import team5 from "../assets/images/team/danny.jpeg";

import team9 from "../assets/images/team/anirudh.jpeg";
import team10 from "../assets/images/team/nagashwin.jpg";

/**
 * Each team member object supports:
 * - id: unique id
 * - img: imported image
 * - name: display name
 * - title: role / subtitle
 * - socials: array of { platform, url, iconClass } (iconClass uses fontawesome classes)
 * - delay: animation delay string (e.g. "0.2s")
 */
export const Admininstrationdata= [
  {
    id: "tm1",
    img: team9,
    name: "Anirudh",
    title: "Administrator",
     socials: [
      { platform: "facebook", url: "#", iconClass: "fa-brands fa-facebook-f" },
      { platform: "youtube", url: "#", iconClass: "fa-brands fa-youtube" },
      { platform: "instagram", url: "#", iconClass: "fa-brands fa-instagram" },
      { platform: "twitter", url: "#", iconClass: "fa-brands fa-x-twitter" },
    ],
    delay: "0s",
  },  
  //   {
  //   id: "tm1",
  //   img: team10,
  //   name: "Nagashwin",
  //   title: "Technical Support",
  //    socials: [
  //     { platform: "facebook", url: "#", iconClass: "fa-brands fa-facebook-f" },
  //     { platform: "youtube", url: "#", iconClass: "fa-brands fa-youtube" },
  //     { platform: "instagram", url: "#", iconClass: "fa-brands fa-instagram" },
  //     { platform: "twitter", url: "#", iconClass: "fa-brands fa-x-twitter" },
  //   ],
  //   delay: "0s",
  // },  
]



export const teamData = [
  {
    id: "tm1",
    img: team1,
    name: "Dr. Jenny",
    title: "Senior Physiotherapist",
    socials: [
      { platform: "facebook", url: "#", iconClass: "fa-brands fa-facebook-f" },
      { platform: "youtube", url: "#", iconClass: "fa-brands fa-youtube" },
      { platform: "instagram", url: "#", iconClass: "fa-brands fa-instagram" },
      { platform: "twitter", url: "#", iconClass: "fa-brands fa-x-twitter" },
    ],
    delay: "0s",
  },
  {
    id: "tm2",
    img: team2,
    name: "Dr. Sireesha",
    title: "Senior Physiotherapist",
    socials: [
      { platform: "facebook", url: "#", iconClass: "fa-brands fa-facebook-f" },
      { platform: "youtube", url: "#", iconClass: "fa-brands fa-youtube" },
      { platform: "instagram", url: "#", iconClass: "fa-brands fa-instagram" },
      { platform: "twitter", url: "#", iconClass: "fa-brands fa-x-twitter" },
    ],
    delay: "0.2s",
  },
  {
    id: "tm3",
    img: team3,
    name: "Dr. Akshay",
    title: "Senior Physiotherapist",
    socials: [
      { platform: "facebook", url: "#", iconClass: "fa-brands fa-facebook-f" },
      { platform: "youtube", url: "#", iconClass: "fa-brands fa-youtube" },
      { platform: "instagram", url: "#", iconClass: "fa-brands fa-instagram" },
      { platform: "twitter", url: "#", iconClass: "fa-brands fa-x-twitter" },
    ],
    delay: "0.4s",
  },
  {
    id: "tm4",
    img: team4,
    name: "Dr. Pushpa",
    title: "Junior Physiotherapist",
    socials: [
      { platform: "facebook", url: "#", iconClass: "fa-brands fa-facebook-f" },
      { platform: "youtube", url: "#", iconClass: "fa-brands fa-youtube" },
      { platform: "instagram", url: "#", iconClass: "fa-brands fa-instagram" },
      { platform: "twitter", url: "#", iconClass: "fa-brands fa-x-twitter" },
    ],
    delay: "0.6s",
  },
  {
    id: "tm5",
    img: team5,
    name: "Dr. Danny",
    title: "Junior Physiotherapist",
    socials: [
      { platform: "facebook", url: "#", iconClass: "fa-brands fa-facebook-f" },
      { platform: "youtube", url: "#", iconClass: "fa-brands fa-youtube" },
      { platform: "instagram", url: "#", iconClass: "fa-brands fa-instagram" },
      { platform: "twitter", url: "#", iconClass: "fa-brands fa-x-twitter" },
    ],
    delay: "0.8s",
  },
 
 
 
];
 